import Tippy from '@tippyjs/react'

import React from 'react'

export const positions = {
  TOP: 'top',
  RIGHT: 'right'
}

const TooltipDetached = ({ anchorEl, label, placement, delay, className }) => {
  return (
    <Tippy
      content={label}
      reference={anchorEl}
      placement={placement}
      delay={delay}
      className={className || undefined}
    />
  )
}

export default TooltipDetached
